import React, { Component } from 'react';
import '../App.css';

class PlayerComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sessions: [],
      selected: false,
    };


  }

  componentWillMount(){
    let arr = [];
    Object.keys(this.props.player).forEach((session) => {
      arr.push({
        id: session,
        session: this.props.player[session]
      });
    });

    this.setState({
      sessions: arr,
    });
  }


  render() {
    return (
      <div onClick={() => this.props.call(this.state.sessions, this.props.text)} className={this.props.text==this.props.id?"selected" : "player"}>
        <p className="basicText">{this.props.text}</p>
      </div>
    );
  }
}

export default PlayerComponent;



// WEBPACK FOOTER //
// ./src/components/playerComponent.js